import EquippedSlot from "./EquippedSlot";
export default EquippedSlot;
